import ddds from 'constants/ddd.json';
import moment from 'moment';

export default (type, value) =>
  ({
    lessToDay() {
      const digitada = moment(value).format('YYYYMMDD');
      const data = moment(new Date()).format('YYYYMMDD');
      return digitada < data;
    },
    afterToday() {
      const digitada = moment(value).format('YYYYMMDD');
      const today = moment(new Date()).format('YYYYMMDD');
      return digitada > today;
    },
    over16() {
      const digitada = moment(value, 'DDMMYYYY');
      const today = moment(new Date(), 'DDMMYYYY');
      return today.diff(digitada, 'years') > 16;
    },
    olderThan16() {
      let formattedISODate = '';
      const today = moment(new Date());

      if (typeof value == 'object') {
        formattedISODate = value;
      } else {
        if (value.indexOf('/') > -1) {
          formattedISODate =
            value
              .split('/')
              .reverse()
              .join('-') + 'T00:00';
        } else {
          formattedISODate = value.replace(/(\d{2})(\d{2})(\d{4})/, '$3-$2-$1T00:00');
        }
      }

      return today.diff(moment(formattedISODate), 'years') >= 16;
    },
    isNotEquals() {
      return value.value !== value.otherValue;
    },
    isBefore() {
      if (value.otherValue === undefined) {
        return true;
      }
      const data = moment(value.value);
      const otherDate = moment(new Date(value.otherValue));
      return !otherDate.isValid() || data > otherDate;
    },
    hour() {
      const match = value.split(':');
      return match.length === 2 && match[0] < 24 && match[1] < 60;
    },
    email() {
      // eslint-disable-next-line
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(value);
    },
    custCode() {
      const re = /^[A-Za-z][A-Za-z0-9]*(?:_[A-Za-z0-9]+)*$/;
      return re.test(value);
    },
    name() {
      return value && value.split(' ').length > 1;
    },
    ddd() {
      return !!ddds.find(ddd => ddd.text.toString() === (value && value.substr(0, 2).toString()));
    },
    phone() {
      return this.ddd() && value.length === 10 && value.charAt(2) < '8';
    },
    cel() {
      return this.ddd() && value.length === 11 && value.charAt(2) > '7';
    },
    celPhone() {
      return this.phone() || this.cel();
    },
    cpfCnpj() {
      return value.length === 11 ? this.cpf() : this.cnpj();
    },
    registration() {
      const re = /^[0-9]+$/;
      return re.test(value);
    },
    newPassword() {
      // eslint-disable-next-line
      const re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\?!@_#\$%\^&\*\.])(?=.{7,})/;
      return re.test(value);
    },
    curve() {
      const re = /[A-F]/;
      return value ? re.test(value) : true;
    },
    cpf() {
      let numeros;
      let digitos;
      let soma;
      let i;
      let resultado;
      let digitosIguais;

      digitosIguais = 1;
      if (value.length < 11) {
        return false;
      }
      for (i = 0; i < value.length - 1; i++) {
        if (value.charAt(i) !== value.charAt(i + 1)) {
          digitosIguais = 0;
          break;
        }
      }
      if (!digitosIguais) {
        numeros = value.substring(0, 9);
        digitos = value.substring(9);
        soma = 0;
        for (i = 10; i > 1; i--) {
          soma += numeros.charAt(10 - i) * i;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        if (resultado.toString() !== digitos.charAt(0).toString()) {
          return false;
        }
        numeros = value.substring(0, 10);
        soma = 0;
        for (i = 11; i > 1; i--) {
          soma += numeros.charAt(11 - i) * i;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        if (resultado.toString() !== digitos.charAt(1).toString()) {
          return false;
        }
        return true;
      }
      return false;
    },
    cnpj() {
      if (
        !value ||
        value.length !== 14 ||
        value === '00000000000000' ||
        value === '11111111111111' ||
        value === '22222222222222' ||
        value === '33333333333333' ||
        value === '44444444444444' ||
        value === '55555555555555' ||
        value === '66666666666666' ||
        value === '77777777777777' ||
        value === '88888888888888' ||
        value === '99999999999999'
      ) {
        return false;
      }
      let tamanho = value.length - 2;
      let numeros = value.substring(0, tamanho);
      const digitos = value.substring(tamanho);
      let soma = 0;
      let pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
      }
      let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
      if (resultado.toString() !== digitos.charAt(0).toString()) return false;
      tamanho += 1;
      numeros = value.substring(0, tamanho);
      soma = 0;
      pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
      }
      resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
      if (resultado.toString() !== digitos.charAt(1).toString()) return false;
      return true;
    },
    money() {
      return value !== '' && value !== 'R$ 0,00';
    },
    validateImei() {
      const stringImeiOnlyNumber = String(value).replace(/\D/g, '');
      if (!stringImeiOnlyNumber) {
        return false;
      }
      if (stringImeiOnlyNumber <= 0) {
        return false;
      }
      const arrayOfDigits = [...stringImeiOnlyNumber];
      if (arrayOfDigits.length !== 15) {
        return false;
      }
      if (arrayOfDigits <= 0) {
        return false;
      }
      const sumOfImeiWithRoles = arrayOfDigits
        .map((item, index) => {
          const newIndex = index + 1;
          if (newIndex % 2 === 0) {
            const tempNumber = +item * 2;
            if (tempNumber > 9) {
              return (tempNumber % 10) + 1;
            }
            return tempNumber;
          }
          return Number(item);
        })
        .reduce((accumulate, actual) => accumulate + actual, 0);
      return !(sumOfImeiWithRoles % 10);
    },
    manySpaces() {
      return value === value.split(/\s+/).join(' ');
    },
    noSpaces() {
      return value === value.split(/\s/).join('');
    },
}[type]());
